module.exports = __webpack_public_path__ + "static/media/rose-card.5f714494.png";